import React, { useState } from 'react'
import styles from './styles.module.css'

function Descriptions ({ record }) {
  const [isExpanded, setIsExpanded] = useState(false)

  // Sort descriptions by dateSeen in descending order
  const sortedDescriptions =
    record?.descriptions?.sort((a, b) => {
      return new Date(b.dateSeen) - new Date(a.dateSeen)
    }) || []

  // Determine the descriptions to display based on isExpanded
  const visibleDescriptions = isExpanded
    ? sortedDescriptions
    : sortedDescriptions.slice(0, 3)

  return (
    <section className={styles.containerMainDescription}>
      <h2 className={styles.titleDescription}>Descriptions</h2>

      <div className={styles.containerDescription}>
        {visibleDescriptions.length > 0 ? (
          visibleDescriptions.map((description, index) => (
            <div className={styles.containerDescriptionValues} key={index}>
              <p className={styles.descriptionValueP}>{description.value}</p>
              <p className={styles.descriptionDateP}>
                {description.dateSeen
                  ? new Intl.DateTimeFormat('en-US', {
                      month: 'long',
                      day: 'numeric',
                      year: 'numeric'
                    }).format(new Date(description.dateSeen))
                  : 'N/A'}
              </p>
            </div>
          ))
        ) : (
          <span className={styles.notFound}>N/A</span>
        )}
      </div>

      {/* Toggle button for expanding/collapsing descriptions */}
      {sortedDescriptions.length > 3 && (
        <button
          className={styles.expandButton}
          onClick={() => setIsExpanded(!isExpanded)}
        >
          {isExpanded
            ? 'Show less'
            : `Expand All (${sortedDescriptions.length})`}
        </button>
      )}
    </section>
  )
}

export default Descriptions
